import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetTaskLocations as GetTaskLocationsGenerated,
  GetTaskLocations_taskLocations as GetTaskLocationsLocationGenerated,
  GetTaskLocationsVariables as GetTaskLocationsVariablesGenerated,
} from "core/queries/__generated__/GetTaskLocations";

export interface GetTaskLocationsVariables
  extends GetTaskLocationsVariablesGenerated {}
export interface GetTaskLocationsResponse extends GetTaskLocationsGenerated {}
export interface GetTaskLocationsLocation
  extends GetTaskLocationsLocationGenerated {}

export const getTaskLocations = gql`
  query GetTaskLocations($filters: TaskLocationFilterInput!) {
    taskLocations(filters: $filters) {
      id
      name
      place
    }
  }
`;

export interface UseGetTaskLocationsQueryOptions {
  skip: boolean;
  variables: GetTaskLocationsVariables;
}

export const useGetTaskLocationsQuery = ({
  skip = false,
  variables,
}: UseGetTaskLocationsQueryOptions) =>
  useQuery<GetTaskLocationsResponse, GetTaskLocationsVariables>(
    getTaskLocations,
    {
      skip,
      variables,
    },
  );
